import React from 'react'
import { Grid, Typography, Box, Divider } from '@mui/material'

/* -------------------------------------------------------
   Substitua estes imports pelos paths REAIS no seu projeto
   (coloque os PNGs em assets/images/updates/coletas)
-------------------------------------------------------- */
import imgListaContratadas from '../../../assets/images/updates/collections-page-update/contracted-collections-list-view.png' // print 4
import imgDetalheContratada from '../../../assets/images/updates/collections-page-update/contracted-collection-list-item-view.png' // print 5
import imgAgendadasCalend from '../../../assets/images/updates/collections-page-update/scheduled-collections-calendar.png' // print 6
import imgAgendadaMTR from '../../../assets/images/updates/collections-page-update/scheduled-collections-mtr-link.png' // print 7
import imgRegistrarAcao from '../../../assets/images/updates/collections-page-update/contracted-collection-day-event-form.png' // print 3
import imgDiaComColetas from '../../../assets/images/updates/collections-page-update/contracted-collection-calendar-day.png' // print 2
import imgContratadasCalend from '../../../assets/images/updates/collections-page-update/contracted-collections-calendar.png' // print 1

const ControleDeColetas: React.FC = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body1" data-cy="update-content">
          Apresentamos a <strong>página especial de Coletas</strong>. Ela reúne, em um só lugar, a visão de
          <strong> coletas contratadas</strong> (vindas do cadastro do cliente) e <strong>coletas agendadas </strong>
          (ações reais que acontecerão), com visualizações em <strong>calendário</strong> e <strong>lista</strong>. Você
          também pode <strong>registrar/editar ações</strong>, definir <strong>status</strong> e
          <strong> vincular MTR</strong>.
        </Typography>
      </Grid>

      {/* 1) PÁGINA & ABAS */}
      <Grid item xs={12}>
        <Typography variant="h6">Visões disponíveis</Typography>
        <Typography variant="body2">
          Use as abas para alternar entre <em>Coletas Contratadas</em> (calendário + lista) e<em> Coletas Agendadas</em>{' '}
          (calendário + lista).
        </Typography>
        <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgContratadasCalend} alt="Calendário das coletas contratadas" style={{ width: '92%' }} />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {/* 2) COLETAS CONTRATADAS */}
      <Grid item xs={12}>
        <Typography variant="h6">Coletas contratadas</Typography>
        <Typography variant="body2">
          Tudo que é registrado no <strong>cadastro do cliente</strong> aparece aqui. Quando a coleta tem frequência
          fixa, ela é exibida no calendário. Também há uma <strong>lista geral</strong> com todas as coletas
          contratadas.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2">Dia com todas as coletas previstas</Typography>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgDiaComColetas} alt="Coletas previstas ao clicar em um dia" style={{ width: '92%' }} />
        </Box>
        <Typography variant="caption">
          Clique em um dia para ver todas as coletas que devem ocorrer naquela data.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2">Detalhe da coleta + registro de ação</Typography>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgRegistrarAcao} alt="Detalhe da coleta contratada e registro de ação" style={{ width: '92%' }} />
        </Box>
        <Typography variant="caption">
          Ao abrir a coleta, você vê os dados dela e pode <strong>registrar uma ação do tipo COLETA</strong>.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle2">Listagem de coletas contratadas</Typography>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgListaContratadas} alt="Listagem geral de coletas contratadas" style={{ width: '92%' }} />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={imgDetalheContratada}
            alt="Detalhe de uma coleta contratada a partir da lista"
            style={{ width: '92%' }}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {/* 3) COLETAS AGENDADAS */}
      <Grid item xs={12}>
        <Typography variant="h6">Coletas agendadas</Typography>
        <Typography variant="body2">
          São as <strong>ações do tipo COLETA</strong> geradas a partir das coletas contratadas — ou seja,
          <em> o que está realmente marcado para acontecer</em> no cliente. Você pode visualizar em calendário ou lista,
          <strong> editar a ação</strong> e <strong>vincular um MTR</strong>.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgAgendadasCalend} alt="Calendário das coletas agendadas" style={{ width: '92%' }} />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box mt={1} sx={{ display: 'flex', justifyContent: 'center' }}>
          <img src={imgAgendadaMTR} alt="Ação de coleta com MTR vinculado" style={{ width: '92%' }} />
        </Box>
        <Typography variant="caption">
          Vincule o <strong>MTR</strong> à ação; os dados também ficam visíveis na <strong>Timeline</strong> do cliente
          para facilitar a operação.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {/* 4) STATUS DOS EVENTOS */}
      <Grid item xs={12}>
        <Typography variant="h6">Status de ações</Typography>
        <Typography variant="body2">
          Ações de coleta agora possuem <strong>status</strong> (ex.: <em>Pendente</em>), permitindo acompanhar a
          execução e priorização pela operação.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ControleDeColetas
